var exports = {
  "U": "x43aef4ae--fa8aa6--arrow",
};

module.exports = exports;
